import { ApplicationService } from "./applicationServices";
import { useForm } from 'react-hook-form';
import { useState } from 'react';

export const fetchEnrolment = async (id) => {
    try {

        const data = await ApplicationService.enrolmentData(id)

        //console.log('enrollmentControler: ', data)
        return (data)


    } catch (error) {
        console.error('Service Error:', error)
        console.error('error response:', error.response)
        throw error
    }
}


export const fetchAppProfessions = async () => {

    try {
        const response = await ApplicationService.applicationProfessions()
        //console.log('applicationProfessions: ', response.data)

        if (response) {
            return response.data
        }

    } catch (error) {

    }
}

export const useAppSubmitForm = (id,radioOption) => {
    const [message, setMessage] = useState(null)
    const [response, setResponse] = useState(null)
    const { register, handleSubmit, formState: { errors }, setValue } = useForm({
        mode: "onBlur",
        defaultValues: {
            kitAddressType: "SameAddress",  
          },
    })

    //console.log('radioOption: ', radioOption)

    const onSubmit = async (data) => {
        try {
            //console.log('data controler es: ', data)

            const additionalParams = {
                enrollmentId: id,
            }
            // const finalData = { ...data, ...additionalParams }
            const finalData = {
                ...additionalParams,
                ...data,
                kitAddressType: radioOption,
                professionId:Array.isArray(data.professionId) && data.professionId.length > 0 ? Number(data.professionId[0].value) : data.professionId 
            }
            //console.log('finalData:', finalData)

            const result = await ApplicationService.sendForm(finalData)
            setResponse(result.status)

            //console.log('respuesta de la api', result)
            setMessage(result.data.message)



        } catch (error) {
            // console.error('El error del controlador fue: ',error);
            // alert(`${error.message}`)
            // throw error

            setMessage(error.message)
            setResponse(error.status)
        }
    }


    return { register, handleSubmit, onSubmit, setValue, message, errors, response }
}